







































import { Component, Vue } from "vue-property-decorator";
import LanguageButton from "@/components/LanguageButton.vue";
import { TweenMax, TimelineMax } from "gsap";
import Sounds from "@/components/Sounds.vue";
@Component({
  components: { LanguageButton, Sounds }
})
export default class HomeEnglish extends Vue {
  $refs!: {
    bgm: HTMLAudioElement;
    se: HTMLAudioElement;
    sounds: Sounds;
  };

  get isFullscreen() {
    return this.$store.state.isFullscreen;
  }

  get mute() {
    return this.$store.state.mute;
  }

  mounted(): void {
    this.$nextTick(() => {
      window.setTimeout(() => {
        this.$refs.sounds.$refs.bgm.play();
      }, 100);
    });
    document.addEventListener("keypress", this.onKeyPress);
    TweenMax.fromTo(
      ".start-btn-container",
      { translateY: "-15%" },
      {
        translateY: "15%",
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: "sine.inOut"
      }
    );

    const tl = new TimelineMax({ repeat: -1 });
    tl.to(".chara-cat", {
      left: "30%",
      duration: 8,
      ease: "none"
    });
    tl.to(
      ".chara-cat",
      {
        top: "12%",
        duration: 1.5
      },
      "<"
    );
    tl.to(
      ".chara-cat",
      {
        top: "0%",
        duration: 1,
        repeat: 5,
        yoyo: true,
        ease: "sine.inOut"
      },
      "<1"
    );

    tl.to(
      ".chara-cat",
      {
        top: "-30%",
        duration: 2
      },
      "-=1"
    );
    tl.fromTo(
      ".chara-mouse",
      {
        scaleX: 1
      },
      {
        left: "100%",
        scaleX: 1,
        duration: 4
      },
      "-=1"
    );
    tl.fromTo(
      ".chara-mouse",
      {
        scaleX: -1
      },
      {
        scaleX: -1,
        left: "-15%",
        duration: 4
      }
    );
    tl.to(".chara-dog", {
      right: 0
    });
    tl.to(".chara-dog", {
      delay: 5,
      right: "-20%"
    });
  }

  destroyed() {
    document.removeEventListener("keypress", this.onKeyPress);
  }

  toggleFullscreen() {
    if (!this.isFullscreen) {
      document.body.requestFullscreen();
      this.$store.dispatch("setFullscreen", true);
    } else {
      document.exitFullscreen();
      this.$store.dispatch("setFullscreen", false);
    }
  }

  onKeyPress(e: KeyboardEvent) {
    if (e.key === "Enter") {
      this.toPrologue();
    }
  }

  toPrologue() {
    this.playSE();
    window.setTimeout(() => {
      this.$router.push("/en/prologue");
    }, 1000);
  }

  playSE() {
    this.$refs.sounds.$refs.se.pause();
    this.$refs.sounds.$refs.se.currentTime = 0;
    this.$refs.sounds.$refs.se.play();
  }

  toggleSounds() {
    this.$store.dispatch("toggleMute");
  }
}
